import { colors } from "../../Styles";

export function User({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M141.73,20.21c32.39,0,55.52,20.99,54.48,62.97-1.04,41.98-29.65,68.09-29.65,68.09-2.08,34.3,16.65,28.67,48.9,39.42,32.25,10.75,30.17,33.79,30.17,33.79-62.94,51.7-144.85,51.7-207.8,0,0,0-2.08-23.04,30.17-33.79,32.25-10.75,50.98-5.12,48.9-39.42,0,0-28.61-26.11-29.65-68.09-1.04-41.98,22.09-62.97,54.48-62.97"/>
    </svg>
  );
}